var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"color":"grey lighten-4","min-width":"200"}},_vm._l((_vm.menus),function(item,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.handleToggle(item)}}},[_c('v-list-item-title',{staticClass:"text-center",domProps:{"textContent":_vm._s(item)}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }